import {baseApi} from "./apiService";
import type {CurrentUser} from "../types";
import {overlayCurrentUser} from "../utils/currentUserOverlay";

export const userApi = baseApi.injectEndpoints({
        overrideExisting: false,
        endpoints: (builder) => ({
            getCurrentUser: builder.query<CurrentUser, void>({
                query: () => ({
                    url: '/me',
                    method: 'GET',
                }),
                transformResponse: overlayCurrentUser,
                providesTags: ['CurrentUser'],
            }),
            // BE 2026-07-05 — PUT /api/change_password/{id} (was a 501 stub).
            // Self-change requires current_password (wrong → 422 envelope,
            // propertyPath current_password); an owner changing a staff
            // member omits it. 400 {error: same_as_current}, 404 unknown id,
            // 403 non-owner targeting someone else. Success revokes the
            // target's refresh tokens — their session lasts until JWT TTL.
            changePassword: builder.mutation<{changed: boolean}, {
                id: string
                current_password?: string
                new_password: string
            }>({
                query(data) {
                    const {id, ...body} = data
                    return {
                        url: `change_password/${id}`,
                        method: 'PUT',
                        body,
                    }
                },
            }),
            updateAnalyticsConsent: builder.mutation<void, {analytics_consent: boolean}>({
                query: (body) => ({
                    url: '/me/analytics-consent',
                    method: 'POST',
                    body,
                }),
            }),
        }),
    }
)

export const {
    useGetCurrentUserQuery,
    useChangePasswordMutation,
    useUpdateAnalyticsConsentMutation,
} = userApi
